import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import React from "react";

const TableLabels = ({ label = "", options = [], size = "small" }) => {
  return (
    <TableContainer>
      <Table size="small">
        <TableBody>
          {options.map((option, index) => (
            <TableRow key={index}>
              <TableCell sx={{ padding: "6px 0px" }}>
                <span
                  className={`font-medium ${
                    option.className || "text-gray-500"
                  }`}
                >
                  {option.label}
                </span>
              </TableCell>
              <TableCell sx={{ padding: "6px 0px" }}>
                <span className={option.className || "text-gray-500"}>
                  : {option.value}
                </span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableLabels;
